import React from "react";

interface BackdropProps {
  show: boolean;
  sidebarHandler: () => void;
}

const Backdrop = ({ show, sidebarHandler }: BackdropProps) => {
  return (
    <div
      className={`backdrop ${show ? "show" : "hide"}`}
      onClick={sidebarHandler}
    ></div>
  );
};

export default Backdrop;
